import { render, staticRenderFns } from "./VEmployeeProfilePersonalInfo.vue?vue&type=template&id=bc9b505e&lang=pug"
import script from "./VEmployeeProfilePersonalInfo.vue?vue&type=script&lang=ts"
export * from "./VEmployeeProfilePersonalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports